import { ConsentIDs } from '../../../../../../hoc/constants/service.constants';
import { EnrollmentContextService } from '../../../../../../hoc/context/enrollment/enrollment-context';

export interface Step {
	name: string;
}

export function getNextSteps(enrollmentCtxt: EnrollmentContextService): Step[] {
	const steps = [];
	if (enrollmentCtxt.getFormField('email')?.value) {
		steps.push({ name: 'email' });
	}
	if (enrollmentCtxt.input.consents.includes(ConsentIDs.tcpa)) {
		steps.push({ name: ConsentIDs.tcpa });
	}
	return steps;
}
